module.exports = "<div> <layout-class layout=a></layout-class> <saved-search-mode-context></saved-search-mode-context> <main role=main> <post-view current-view=currentView() filters=filters> </post-view> </main> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/savedsearches/savedsearches.html
// module id = 812
// module chunks = 0